import React from "react";
import "./Styles/Banner.css";

export const Banner = () => {
    return (
        <div className="home_banner">
            <img src="/Images/banner-image.png" alt="bannerImage" />
        </div>
    );
};